import { render } from "./AboutComp.vue?vue&type=template&id=7d4b7436"
import script from "./AboutComp.vue?vue&type=script&lang=js"
export * from "./AboutComp.vue?vue&type=script&lang=js"

import "./AboutComp.vue?vue&type=style&index=0&id=7d4b7436&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\compro.rimba.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__